module.exports = __webpack_public_path__ + "static/media/vzhod-zahod-sever-ali-jug.17c0dbac.png";